export const formatDateID = (dateString) => {
    return new Date(dateString).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
};

export const toTitleCase = (text) => {
    const normalized = text.trim().toUpperCase();
    if (normalized === "JAKARTA SELATAN") {
        return "Jakarta";
    }
    return text
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const formatEventDate = (
    timeEvent,
    durationHours = 4,
    locale = "id-ID"
) => {
    // convert "YYYY-MM-DD HH:mm:ss" → ISO
    const startDate = new Date(timeEvent.replace(" ", "T"));
    // clone date untuk end time
    const endDate = new Date(startDate);
    endDate.setHours(endDate.getHours() + durationHours);

    const day = startDate.getDate();
    const month = startDate
        .toLocaleString(locale, { month: "short" })
        .toUpperCase();
    const year = startDate.getFullYear();

    const startTime = startDate.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });

    const endTime = endDate.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
    return {
        day,
        month,
        year,
        timeRange: `${startTime} - ${endTime}`,
    };
};

export const formatDateLabel = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
    }).toUpperCase();
};

export const formatDay = (dateStr) =>
    new Date(dateStr).toLocaleDateString("id-ID", { weekday: "long" }).toUpperCase();

export const getTimezoneSuffix = (city = "") => {
    if (!city) return "WIB";
    const normalized = city.trim().toUpperCase();

    const witaCities = ["MAKASSAR", "DENPASAR"];
    if (witaCities.some(c => normalized.includes(c))) {
        return "WITA";
    }

    // const witCities = ["AMBON", "JAYAPURA", "PAPUA", "TERNATE", "MANOKWARI", "SORONG"];
    // if (witCities.some(c => normalized.includes(c))) {
    //     return "WIT";
    // }

    return "WIB";
};

export const formatTimeRange = (dateStr, city = "") => {
    const start = new Date(dateStr);
    const end = new Date(start.getTime() + 4 * 60 * 60 * 1000); // default 4 jam

    const format = (d) =>
        d.toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
        });

    const timezone = getTimezoneSuffix(city);

    return `${format(start)} – ${format(end)} ${timezone}`;
};